import { ExamPrimarySettings } from "./exams/tabs/ExamPrimarySettings";
import { ExamPublish } from "./exams/tabs/ExamPublish";
// import { BankPoolForm } from "./bank-pool/BankPoolForm";
import  BankPoolListItem  from "./bank-pool/BankPoolListItem";
import { BankPoolTable } from "./bank-pool/BankPoolTable";
import { chooseFormByQuestionType } from "./bank-pool/helpers";

import { ExamQuestionGroupForm } from "./exams/groups/ExamQuestionGroupForm";
import { ExamQuestionGroupItemList } from "./exams/groups/ExamQuestionGroupItemList";
import { ExamQuestionGroupSettingsForm } from "./exams/groups/ExamQuestionGroupSettingsForm";


import { ExamPeriodPrimarySettings } from "./exam-period/tabs/ExamPeriodPrimarySettings";
import { ExamPeriodUsers } from "./exam-period/tabs/ExamPeriodUsers";
import { ExamPeriodPublish } from "./exam-period/tabs/ExamPeriodPublish";
import { ExamsListItem } from "./exam-period/ExamsListItem";
import { ExamPeriodActivityTableActions } from "./exam-period/ExamPeriodActivityTableActions";
import { ExamPeriodMonitorTable } from "./exam-period/monitor/ExamPeriodMonitorTable";

import { CategoryForm } from "./categories/CategoryForm";
import { CategoriesTableActions } from "./categories/CategoriesTableActions";
import { EmailTemplateForm } from "./email-templates/EmailTemplateForm";
import { EmailTemplatesTableActions } from "./email-templates/EmailTemplatesTableActions";
import { ReportTableActions } from "./reports/ReportTableActions";
import { MyFormItem, MyFormItemGroup } from "./custom-form-item/CustomFormItem";
import { TableFilterDropdown } from "./TableFilterDropdown";
import { QuestionTableActions } from "./exams/QuestionTableActions";
import { SettingsDrawer } from "./navbar/SettingsDrawer";
import { setTimeWithSeconds } from "./helpers";
import { CommonExamQuestionsTab } from "./CommonExamQuestionsTab";
import { GradingConfigurationSelect } from "./grading/GradingConfigurationSelect";
import { LevelDReportFilters, LevelDOverallStats, LevelDCompetencyChart, LevelDCandidateTable, LevelDCandidateDetail, LevelDExportButton, LevelDTrendChart, LevelDParticipantCompetencyTable } from "./leveld-reports";
import { LevelCReportFilters, LevelCOverallStats, LevelCCompetencyChart, LevelCCandidateTable, LevelCCandidateDetail, LevelCExportButton, LevelCTrendChart, LevelCParticipantCompetencyTable } from "./levelc-reports";
import {lazy} from "react";

const BankPoolForm = lazy(() => import("./bank-pool/BankPoolForm"));

export {
    ExamPrimarySettings,
    ExamPublish,

    BankPoolForm,
    BankPoolListItem,
    BankPoolTable,

    ExamQuestionGroupForm,
    ExamQuestionGroupItemList,
    ExamQuestionGroupSettingsForm,

    ExamPeriodPrimarySettings,
    ExamPeriodUsers,
    ExamPeriodPublish,
    ExamsListItem,
    ExamPeriodActivityTableActions,
    QuestionTableActions,
    ExamPeriodMonitorTable,

    MyFormItem,
    MyFormItemGroup,
    ReportTableActions,

    CategoryForm,
    CategoriesTableActions,
    EmailTemplateForm,
    EmailTemplatesTableActions,
    TableFilterDropdown,
    SettingsDrawer,
    CommonExamQuestionsTab,
    GradingConfigurationSelect,
    LevelDReportFilters,
    LevelDOverallStats,
    LevelDCompetencyChart,
    LevelDCandidateTable,
    LevelDCandidateDetail,
    LevelDExportButton,
    LevelDTrendChart,
    LevelDParticipantCompetencyTable,
    LevelCReportFilters,
    LevelCOverallStats,
    LevelCCompetencyChart,
    LevelCCandidateTable,
    LevelCCandidateDetail,
    LevelCExportButton,
    LevelCTrendChart,
    LevelCParticipantCompetencyTable,

    chooseFormByQuestionType,
    setTimeWithSeconds
}